import { useState, useCallback } from 'react';
import { message } from 'antd';
import { h302Api, QueryParams, ReportRow, VendorSummary } from '../../../services/h302Api';

export function useH302Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [summaries, setSummaries] = useState<VendorSummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await h302Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setSummaries(resp.summaries || []);
        setNoData(false);
      } else {
        setData([]);
        setSummaries([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setSummaries([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, summaries, queried, noData, runQuery, reset };
}
